module.exports = __webpack_public_path__ + "img/wei5.63cef2cf.jpg";